// src/hooks/useSplitTextAnimation.js
import { useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";

gsap.registerPlugin(ScrollTrigger, SplitText);

const useSplitTextAnimation = () => {
  useEffect(() => {
    const splitTextLines = gsap.utils.toArray(".splittext-line");

    splitTextLines.forEach((splitTextLine) => {
      const itemSplitted = new SplitText(splitTextLine, { type: "lines" });
      gsap.set(splitTextLine, { perspective: 400 });

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: splitTextLine,
          start: "top 90%",
          end: "bottom 60%",
          scrub: false,
          markers: false,
          toggleActions: "play none none none",
        },
      });

      tl.from(itemSplitted.lines, {
        duration: 1,
        delay: 0.5,
        opacity: 0,
        rotationX: -80,
        force3D: true,
        transformOrigin: "top center -50",
        stagger: 0.1,
      });
    });

    return () => {
      splitTextLines.forEach((line) => {
        const split = SplitText.get(line);
        if (split) split.revert();
      });
    };
  }, []);
};

export default useSplitTextAnimation;
